import React, { useState, useRef, useContext, useEffect } from "react";
import { Tooltip } from "@kdcloudjs/kdesign";

function KDTooltip(props) {
  const [visible, setVisible] = useState(false);
  const parentRef = useRef(null);
  const contentRef = useRef(null);
  const [overWidth, setOVerWidth] = useState(false);

  const { tip, placement, className, style, content, innerstyle } = props;
  const onMouseEnter = () => {
    if (
      parentRef.current.offsetWidth < contentRef.current.offsetWidth ||
      overWidth
    ) {
      setVisible(true);
    }
  };

  useEffect(() => {
    if (parentRef.current.offsetWidth < contentRef.current.offsetWidth) {
      setOVerWidth(true);
    }
  }, []);

  const onMouseLeave = () => {
    if (!visible) return;
    setVisible(false);
  };
  return (
    <Tooltip visible={visible} tip={tip} placement={placement || "top"}>
      <div
        onMouseEnter={onMouseEnter}
        ref={parentRef}
        onMouseLeave={onMouseLeave}
        className={["single-line", className ? className : ""].join(" ")}
        style={{ ...style, display: "flex", alignItems: "center" }}
      >
        <span
          style={
            overWidth
              ? {
                  display: "inline-block",
                  maxWidth: "100%",
                  ...innerstyle,
                }
              : {
                  display: "inline-block",
                  ...innerstyle,
                }
          }
          className={overWidth ? "single-line" : ""}
          ref={contentRef}
        >
          {content}
        </span>
      </div>
    </Tooltip>
  );
}

export default KDTooltip;
